import { render, staticRenderFns } from "./LessonContent.vue?vue&type=template&id=7239ba4c&scoped=true"
import script from "./LessonContent.vue?vue&type=script&lang=js"
export * from "./LessonContent.vue?vue&type=script&lang=js"
import style0 from "./LessonContent.vue?vue&type=style&index=0&id=7239ba4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7239ba4c",
  null
  
)

export default component.exports